import { withStyles } from '@material-ui/core';

export const jsonEditorStyles = {
  container: { borderRadius: '0.125em' },
  body: { fontSize: '1em', height: '100%', padding: '0.5em 0' },
  warningBox: { opacity: '0', height: '0' },
};

export const styles = () => ({
  root: {},
  fullWidthRow: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  key: {
    width: '100%',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    alignItems: 'inherit',
  },
  link: {
    '&:hover': {
      cursor: 'pointer',
      color: 'rgb(48,183,255)',
    },
  },
  domainHeading: {
    fontSize: '1.125em',
    fontWeight: '600 !important',
  },
  addIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  settingsIcon: {
    '&.loading': {
      animationName: 'rotate',
      animationDuration: '2s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      '& :hover': {
        cursor: 'progress',
      },
    },
  },
  editorError: {
    color: 'red',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '0.5em',
    textAlign: 'center',
    lineHeight: '1.55em',
    '&.emphasize': {
      animationName: 'shake',
      animationDuration: '1s',
      animationIterationCount: '1',
      animationTimingFunction: 'cubic-bezier(.36,.07,.19,.97)',
      animationFillMode: 'both',
    },
    '& > *': {
      marginRight: '0.5em',
    },
  },
  editorErrorIcon: {
    fill: 'red',
  },
  editorErrorCloseButton: {
    stroke: 'red',
    strokeWidth: '0.125em',
    '& path[fill="none"]': {
      strokeWidth: '0',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  saveIcon: {
    height: '2em',
    width: '2em',
    margin: '0.5em 0',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  keySpaceContextMenu: {
    right: '-11em',
  },
  hide: {
    opacity: '0',
    maxHeight: '0',
    transition: 'opacity 0.4s linear, max-height 0.25s cubic-bezier(0.000, 1.125, 0.190, 0.925)',
  },
  show: {
    opacity: '1',
    maxHeight: '100em',
    transition: 'opacity 0.4s linear, max-height 0.25s cubic-bezier(0.890, 0.740, 1.000, 0.005)',
  },
  shadow: {
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)',
  },
  basicAuthControlsContainer: {

  },
  basicAuthTokenText: {
    width: 'calc(100% - 110px)',
    display: 'inline-block',
  },
  basicAuthLoadButton: {
    width: '100px',
    borderRadius: '5px',
    display: 'inline-block',
    margin: '0px',
    marginLeft: '10px',
    marginTop: '25px',
  },
  '@keyframes rotate': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
  '@keyframes shake': {
    '10%, 90%': {
      transform: 'translate3d(-1px, 0, 0)',
    },
    '20%, 80%': {
      transform: 'translate3d(2px, 0, 0)',
    },
    '30%, 50%, 70%': {
      transform: 'translate3d(-4px, 0, 0)',
    },
    '40%, 60%': {
      transform: 'translate3d(4px, 0, 0)',
    },
  },
  '@keyframes slide': {
    '0%': {
      opacity: '0',
      transform: 'scaleY(0)',
      transformOrigin: 'top',
    },
    '100%': {
      opacity: '1',
      transform: 'scaleY(1)',
      transformOrigin: 'top',
    },
  },
});

export const withBaseStyles = withStyles(styles);

export default styles;
